import { render } from "./ExportPotentialService.vue?vue&type=template&id=5ce1779e"
import script from "./ExportPotentialService.vue?vue&type=script&lang=js"
export * from "./ExportPotentialService.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__